<div class="st-cast-objects__header">
    <span
        class="st-cast-objects__header__title"
        [matTooltip]="languageSettings.PSTWebStorytellingObjectsLabel"
        >{{ languageSettings.PSTWebStorytellingObjectsLabel }}</span
    >
    <div>
        <button
            mat-icon-button
            class="st-cast-objects__header__actions-button"
            (click)="reset()">
            <mat-icon
                fontSet="material-symbols-outlined"
                class="st-cast-objects__header__actions-icon"
                >restart_alt</mat-icon
            >
        </button>
        <button
            mat-icon-button
            class="st-cast-objects__header__actions-button"
            (click)="toggleCastObjectsElevation()">
            <mat-icon
                fontSet="material-symbols-outlined"
                class="st-cast-objects__header__actions-icon"
                >push_pin</mat-icon
            >
        </button>
        <button
            mat-icon-button
            class="st-cast-objects__header__actions-button"
            (click)="closeCastObjects.emit()">
            <mat-icon
                fontSet="material-symbols-outlined"
                class="st-cast-objects__header__actions-icon"
                >close</mat-icon
            >
        </button>
    </div>
</div>

<div class="st-cast-objects-list">
    <div class="st-cast-objects-list__grid">
        <mat-button-toggle-group
            class="st-cast-objects-list-buttons-group"
            [(ngModel)]="selectedListSearchType"
            (change)="toggleSearchTab()">
            <mat-button-toggle
                class="st-cast-objects-list-buttons-group__search"
                [value]="SearchType.SEARCH">
                {{ languageSettings.PSTWebCastSearchTabLabel }}
            </mat-button-toggle>
            <mat-button-toggle
                class="st-cast-objects-list-buttons-group__views"
                [value]="SearchType.SAVED">
                {{ languageSettings.PSTWebSavedViewsTabLabel }}
            </mat-button-toggle>
        </mat-button-toggle-group>

        <div class="st-cast-objects-list__grid__right">
            @if (savedViewDropdownVisible()) {
                <mat-form-field
                    class="st-cast-objects-list__views-dropdown"
                    subscriptSizing="dynamic">
                    <mat-label>{{ languageSettings.PSTWebCastObjectsDropDownLabel }}</mat-label>
                    <mat-select
                        [value]="currentViewState()?.guid"
                        [placeholder]="languageSettings.PSTWebSavedViewsLabel"
                        (selectionChange)="onViewStateGuidChanged($event)">
                        @for (item of savedViewStates(); track item.guid) {
                            <mat-option [value]="item.guid">
                                {{ item.title }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            } @else {
                <div class="st-cast-objects-list__search-bar">
                    <st-simple-search-box-autocomplete
                        st-click-stop-propagation
                        class="st-cast-objects-list__search-bar__search"
                        (searchExecute)="onSearchHandler($event)" />
                </div>
            }
        </div>
    </div>
    @if (!loadingRecords()) {
        <cdk-virtual-scroll-viewport
            class="st-cast-objects-items"
            itemSize="64"
            cdkScrollable
            id="candidates"
            cdkDropList
            sortingDisabled
            [cdkDropListConnectedTo]="'publication-list-sections'">
            <st-cast-object-item
                *cdkVirtualFor="let node of records(); last as isLast; trackBy: trackByGuid; templateCacheSize: 0"
                cdkDrag
                [cdkDragDisabled]="disabledCastObjects()"
                [class.st-cast-objects-disabled]="disabledCastObjects()"
                [data]="node.object"
                [isLast]="isLast"
                [dragStarted]="dragStarted()"
                (cdkDragStarted)="onDragStarted(node)"
                (cdkDragEnded)="onDragEnded()"
                (itemClick)="onItemClickHandler(node)">
                <div
                    *cdkDragPreview
                    class="st-cast-object-item-drag-preview">
                    <st-cast-object-item [data]="node.object" />
                </div>
            </st-cast-object-item>
        </cdk-virtual-scroll-viewport>
    } @else {
        <st-loader
            class="st-cast-objects-loader"
            [diameter]="120"
            [productLabel]="languageSettings.PSTWebLoadingLabel"
            [strokeWidth]="10" />
    }
</div>

@if (showAddAllButton()) {
    <button
        type="button"
        mat-button
        class="st-cast-objects-button-add-all"
        [disabled]="disabledAddAllButton()"
        (click)="addAll()">
        <mat-icon fontSet="material-symbols-outlined">add</mat-icon>
        {{ languageSettings.PSTWebAddAllLabel }}
    </button>
}
